import { render } from "./SearchResult.vue?vue&type=template&id=067bc8e9&scoped=true"
import script from "./SearchResult.vue?vue&type=script&lang=js"
export * from "./SearchResult.vue?vue&type=script&lang=js"

import "./SearchResult.vue?vue&type=style&index=0&id=067bc8e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-067bc8e9"]])

export default __exports__